import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

export type Inputs = "idVendedor" | "razonCambioVendedor";
export type Buttons = "aceptar" | "cancelar";

export const cambiarVendedorFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "idVendedor",
      label: "* Vendedor",
      bts: { mCol: 12 },
      component: IUserSelectorBuilder,
      props: {}
    },
    {
      name: "razonCambioVendedor",
      label: "Razón del cambio",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        rows: 3
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: { mCol: 6 },
      component: IButtonBuilder
    }
  ],
  validations: {
    idVendedor: {
      required: {
        validator: value => !value,
        message: () => "El vendedor es requerido"
      }
    }
  },
  rows: [["idVendedor"], ["razonCambioVendedor"], ["aceptar", "cancelar"]]
};
